export default __webpack_public_path__ + "static/media/shrimp.b743a8f9.png";